import { sessionStatus } from './../../models/user.interface';
import { LanguageService } from '../../services/language.service';
import { AuthService } from '../../services/auth.service';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, OnInit, ViewChildren } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Router, NavigationEnd } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AgentService } from './../../services/agent.service'
import { LocalService } from '../../services/local.service';

interface notification {
  round: string;
  icon?: string;
  image?: string;
  title: string;
  subject: string;
  time: string;
}

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements AfterViewInit, OnInit, OnDestroy {

  @Output() toggleSidebar = new EventEmitter<void>();
  @Input() showMiniSidebar;
  @Input() companyList;
  @ViewChildren(NgbDropdown) dropdown: NgbDropdown;
  @Output()
  closeChatBox: any = new EventEmitter();
  private _unsub$ = new Subject<boolean>();
  public userSessionStatus: sessionStatus = { id: 5, name: "undefined" };
  public userRoute: string;
  public userRole: number;

  public config: PerfectScrollbarConfigInterface = {};
  constructor(
    public auth: AuthService,
    private router: Router,
    private translateService: TranslateService,
    private agentService: AgentService,
  ) {
    this.userRole = this.auth.user.role.id;
  }

  // This is for Notifications
  notifications: Array<notification> = [
    /* {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    } */
  ];
  settings: any;

  ngAfterViewInit() { }

  ngOnInit() {
    if (this.userRole === 5) {
      this.toggleSidebar.emit();
      this.userRoute = this.router.url;
      this.router.events
        .pipe(takeUntil(this._unsub$))
        .subscribe((router: NavigationEnd) => {
          (router instanceof NavigationEnd) ?
            this.userRoute = router.url :
            undefined;
        });

      this.agentService.listen('getTransferContact')
        .pipe(takeUntil(this._unsub$))
        .subscribe((response: any) => {
          if (response !== null && typeof response === 'object') {
            const newNotification =
            {
              round: 'round-success',
              icon: 'ti-link',
              title: 'Luanch Admin',
              subject: 'Se ha transferido un contacto nuevo, revisa tu bandeja de conversaciones.',
              time: '9:30 AM'
            }
            this.notifications.push(newNotification);
          }
        });

      this.agentService.agentSessionStatus$
        .pipe(takeUntil(this._unsub$))
        .subscribe((status: sessionStatus) => {
          this.userSessionStatus = status;
        });
    }
  }

  ngOnDestroy() {
    this._unsub$.next(true);
    this._unsub$.complete();
  }

  public changeSessionStatus(status: sessionStatus) {
    this.userSessionStatus = status
  }

  removeNotification(index) {
    this.notifications.splice(index, 1);
  }

  changeCompany(event, companies) {
    function searchCompany(company) {
      return company.id === parseInt(event.target.value, null);
    }
    const companySend = companies.find(searchCompany);
    this.auth.changeCompany(companySend);
    sessionStorage.clear();
    location.reload();
    this.router.navigate(['admin/dashboard']);
  }

  logout() {
    this.auth.logout();
  }

  formatRole(role) {
    switch (role) {
      case 'superadmin':
        return this.translateService.instant('shared.headerNavigation.superadminRole');
      case 'admin':
        return this.translateService.instant('shared.headerNavigation.adminRole');
      case 'trainer':
        return this.translateService.instant('shared.headerNavigation.trainerRole');
      case 'consultant':
        return this.translateService.instant('shared.headerNavigation.consultantRole');
    }
  }
}
